import { createTheme } from '@mui/material/styles';

import { DA_DIREKT_THEME } from '../theme';
import colors from '../tokens/colors';
import { daDirektFontFamily } from '../tokens/fonts';
import typography from '../tokens/typography/daDirekt';

import baseTheme from './base.theme';

// base component styles
import { accordionDaDirekt } from '../components/accordion.style';
import { autocompleteDaDirekt } from '../components/autocomplete.style';
import { buttonDaDirekt } from '../components/button.style';
import { checkboxDaDirekt } from '../components/checkbox.style';
import { emailDaDirekt } from '../components/email.style';
import { inputDaDirekt } from '../components/input.style';
import { linkDaDirekt } from '../components/link.style';
import { listDaDirekt } from '../components/list.style';
import { phoneDaDirekt } from '../components/phone.style';
import { radioDaDirekt } from '../components/radio.style';
import { selectDaDirekt } from '../components/select.style';
import { toggleSwitchDaDirekt } from '../components/toggleSwitch.style';

// widget styles
import { backButtonDaDirekt } from '../widgets/backButton.style';
import { daDirektCodeDaDirekt } from '../widgets/daDirektCode.style';
import { formLabelDaDirekt } from '../widgets/formLabel.style';
import { informationTextDaDirekt } from '../widgets/informationText.style';
import { pageHeaderDaDirekt } from '../widgets/pageHeader.style';
import { priceButtonDaDirekt } from '../widgets/priceButton.style';

const theme = createTheme(baseTheme, {
  name: DA_DIREKT_THEME,
  palette: {
    background: {
      primary: colors.DA_DIREKT_BACKGROUND_1,
      accordion: {
        header: colors.WHITE,
        body: colors.WHITE,
        footer: colors.WHITE,
      },
      button: colors.DA_DIREKT_VISUAL_BRAND_ORANGE,
      input: colors.WHITE,
      modalOverlay: colors.PRODUCT_BLUE,
      pageHeaderTitle: 'transparent',
      selectOption: colors.WHITE,
    },
    text: {
      primary: colors.PROFESSIONAL_BLUE,
      secondary: colors.DA_DIREKT_GRAY_3,
      accent: colors.DA_DIREKT_VISUAL_BRAND_ORANGE,
      button: colors.WHITE,
      checkbox: colors.PROFESSIONAL_BLUE,
      input: colors.PROFESSIONAL_BLUE,
      label: colors.PROFESSIONAL_BLUE,
      placeholder: colors.DA_DIREKT_GRAY_3,
    },
    error: {
      main: colors.DA_DIREKT_ERROR_RED,
    },
    success: {
      main: colors.DA_DIREKT_SUCCESS,
    },
  },
  shadows: [
    baseTheme.shadows[0],
    baseTheme.shadows[1],
    'none',
    'none',
    'none',
    `0 0 15px 0 rgba(0, 50, 100, 0.08)`,
    baseTheme.shadows[6],
    baseTheme.shadows[7],
  ],
  typography: {
    fontFamily: daDirektFontFamily,
    ...typography,
  },
  components: {
    accordion: accordionDaDirekt,
    autocomplete: autocompleteDaDirekt,
    button: buttonDaDirekt,
    checkbox: checkboxDaDirekt,
    email: emailDaDirekt,
    input: inputDaDirekt,
    link: linkDaDirekt,
    list: listDaDirekt,
    phone: phoneDaDirekt,
    radio: radioDaDirekt,
    select: selectDaDirekt,
    toggleSwitch: toggleSwitchDaDirekt,
  },
  widgets: {
    backButton: backButtonDaDirekt,
    daDirektCode: daDirektCodeDaDirekt,
    formLabel: formLabelDaDirekt,
    informationText: informationTextDaDirekt,
    pageHeader: pageHeaderDaDirekt,
    priceButton: priceButtonDaDirekt,
  },
});

export default theme;
